declare global {
    interface Window {
        cmplz_has_consent?: (category: string) => boolean;
    }
}

const VIMEO_ORIGIN = 'https://player.vimeo.com';

const background = document.querySelector<HTMLElement>('.hero-home .hero-background');
const iframe = background?.querySelector<HTMLIFrameElement>('iframe[data-vimeo-src]');
const video = background?.querySelector('video');

const showVimeo = () => {
    if (!iframe || iframe.classList.contains('is-playing')) return;

    iframe.classList.add('is-playing');
    setTimeout(() => video?.remove(), 500);
};

const loadVideo = () => {
    if (!iframe || iframe.hasAttribute('src')) return;

    if (video) {
        video.pause();
        video.currentTime = 0;
    }

    iframe.src = iframe.dataset.vimeoSrc as string;

    iframe.addEventListener('load', () => setTimeout(showVimeo, 5000), {once: true});
};

if (iframe) {
    window.addEventListener('message', (event) => {
        if (event.origin !== VIMEO_ORIGIN || event.source !== iframe.contentWindow) return;

        let data = event.data;
        if (typeof data === 'string') {
            try {
                data = JSON.parse(data);
            } catch {
                return;
            }
        }

        if (data?.event === 'ready') {
            iframe.contentWindow?.postMessage({method: 'addEventListener', value: 'timeupdate'}, VIMEO_ORIGIN);
        } else if (data?.event === 'timeupdate') {
            showVimeo();
        }
    });

    if (window.cmplz_has_consent?.('marketing')) {
        loadVideo();
    }

    document.addEventListener('cmplz_enable_category', (event) => {
        if ((event as CustomEvent).detail?.category === 'marketing') {
            loadVideo();
        }
    });

    window.addEventListener('load', () => {
        if (!window.cmplz_has_consent) {
            loadVideo();
        }
    });
}

export {};
